import { FC } from "react";
import { FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useBreakPenalty } from "@sinch/components/application/RateInterval/CreateInterval/BreakPenalty/BreakPenaltyProvider";
import { DurationInput } from "@sinch/components/form/DurationInput/DurationInput";
import { useMuiController } from "@sinch/components/index";

/**
 * How much work has to pass before a break is required
 */
export const BreakAfterDurationField: FC = () => {
  const { t } = useTranslation();
  const { path, disabled } = useBreakPenalty();
  const { field } = useMuiController<FieldValues, string>({ name: `${path}.breakAfterMinutes`, disabled });

  return <DurationInput {...field} fullWidth label={t("RateUnit.breakAfterDuration")} min={1} />;
};
